<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="pull-left">
        <h5>
          Mail Subscriptions
        </h5>
      </div>

      <div v-if="person.data.email" class="pull-right">
        <a
            href="#create-mail-subscription-modal"
            class="btn btn-black btn-sm"
            data-toggle="modal"
            style="margin-top: 4px"
        >
          <i class="fa fa-envelope"></i> Subscribe
        </a>
      </div>

      <div class="clearfix"></div>
    </div>

    <LoadingSpinner v-if="loading" style="margin: 30px"/>

    <ul v-else class="list-group">
      <template v-if="person.data.email">
        <li v-if="!mailSubscriptions" class="list-group-item text-center" style="padding: 30px">
          <i>
            Mail subscriptions could not be loaded.
          </i>
        </li>

        <template v-else-if="mailSubscriptions">
          <li class="list-group-item" v-for="mailSubscription in mailSubscriptions">
            <div class="row">
              <div class="col-xs-12">
                {{ getListName(mailSubscription) }}

                <span v-if="mailSubscription.attributes.frequency === 'high'" class="label label-success">
                  Høj
                </span>

                <span v-if="mailSubscription.attributes.frequency === 'medium'" class="label label-warning">
                  Mellem
                </span>

                <span v-if="mailSubscription.attributes.frequency === 'low'" class="label label-danger">
                  Lav
                </span>
              </div>

              <div class="col-xs-8">
                <i class="fa fa-star" v-for="n in mailSubscription.attributes.rating"></i>
              </div>

              <div class="col-xs-4 text-right">
                <button type="button" class="btn" @click="edit(mailSubscription)" style="padding: 0">
                  <i class="fa fa-search"></i>
                </button>

                <button type="button" class="btn" @click="destroy(mailSubscription)" style="padding: 0">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </li>
        </template>

        <li v-else class="list-group-item text-center" style="padding: 30px">
          <i>
            The person is not subscribed to any mailing lists.
          </i>
        </li>
      </template>

      <li v-else class="list-group-item text-center" style="padding: 30px">
        <i>
          The person does not have an email address.
        </i>
      </li>
    </ul>

    <CreateMailSubscriptionModal
        :person="person"
        @created="mailSubscriptions.push($event)"
    />

    <EditMailSubscriptionModal
        :person="person"
        :mail-subscription="editing"
        @updated="updated"
    />
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import CreateMailSubscriptionModal from '@/pages/People/People/Edit/Tabs/Dashboard/Modals/CreateMailSubscription'
import EditMailSubscriptionModal from '@/pages/People/People/Edit/Tabs/Dashboard/Modals/EditMailSubscription'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {CreateMailSubscriptionModal, EditMailSubscriptionModal, LoadingSpinner},

  props: ['person'],

  data() {
    return {
      mailingLists: null,
      mailSubscriptions: null,

      editing: null,
      loading: true
    }
  },

  mounted() {
    if (this.person.data.email) {
      return this.load()
    }

    this.loading = false
  },

  methods: {
    load() {
      this.loading = true

      Promise.all([
        http.get('/api/v2/external/mailing-lists')
            .then(response => this.mailingLists = response.data.data),
        http.get('/api/v2/external/mail-subscriptions', {'filter[email]': this.person.data.email})
            .then(response => this.mailSubscriptions = response.data.data)
            .catch(error => this.mailSubscriptions = null)
      ]).then(() => this.loading = false)
    },

    getListName(mailSubscription) {
      return this.mailingLists.find(mailingList => mailingList.id === mailSubscription.attributes.list_id).attributes.name
    },

    edit(mailSubscription) {
      this.editing = mailSubscription

      $('#edit-mail-subscription-modal').modal('show')
    },

    updated(mailSubscription) {
      this.mailSubscriptions.splice(this.mailSubscriptions.findIndex(existing => existing.id === mailSubscription.id), 1, mailSubscription)
    },

    destroy(mailSubscription) {
      modal.confirm('Are you sure that you want to remove the mail subscription?', () => {
        http.delete('/api/v2/external/mail-subscriptions/' + mailSubscription.attributes.list_id + '/' + mailSubscription.id)
            .then(() => {
              notify.success('The subscription was removed')

              this.mailSubscriptions.splice(this.mailSubscriptions.findIndex(existing => existing.id === mailSubscription.id), 1)
            })
            .catch(error => {
              if (error.response.status === 400) {
                return notify.error(error.response.data.message)
              }

              throw error
            })
      })
    }
  }
}
</script>
